import { useContext, useEffect, useState } from "react";
import PopupContext from "../../../context/context-popup";

import SidePopup from "../../../components/side-popup";
import List from "../../../components/list";
import InputsTextArea from "../../../components/inputs/inputs-text-area";
import { ButtonCancel, ButtonModify, ButtonRemove, ButtonSave, ButtonReturn } from "../../../components/buttons";
import meetingsApi from "../../../lib/meetings/meetings-api";
import InputsText from "../../../components/inputs/inputs-text";
import ContentDropdown from "../../../components/content-dropdown";
import LabelContainer from "../../../components/label-container";
import Container from "../../../layouts/containers/container";
import Row from "../../../components/row";
import InputsCheckbox from "../../../components/inputs/inputs-checkbox";

import { toast } from 'react-toastify';
import ErrorContainer from "../../../components/error-container";
import InputsDropdown from "../../../components/inputs/inputs-dropdown";
import Divider from "../../../components/divider/divider";
import companiesApi from "../../../lib/companies/companies-api";
import Blurred from "../../../components/blurred";

import Validator from 'validatorjs';

export default function PopupsAttendeesManual({
    attendees = [],
    onAttendeeAdd,
    onAttendeeDelete,
    onAttendeeUpdate,
    howManyTicketsLeftMapped,
}) {
    const { closePopup } = useContext(PopupContext);
    const [ errors, setErrors ] = useState({});
    const [ members, setMembers ] = useState([]);

    const [ params, setParams ] = useState({});

    const [ personSelected, setPersonSelected ] = useState(null);

    let rules = {
        event_ticket_type_id: 'required',
        attendee_details: {
            first_name: 'required',
            last_name: 'required',
            email_address: 'required|email',
        }
    };

    let userRules = {
        attendee_id: 'required',
        event_ticket_type_id: 'required',
    };

    const save = () => {
        const typeOfRules = personSelected !== null ? userRules : rules;
        
        let validation = new Validator(params, typeOfRules, {
            'required.event_ticket_type_id': 'Event ticket type is required',
            'required.attendee_id': 'Attendee id is required',
            'required.attendee_details.first_name': 'First name is required',
            'required.attendee_details.last_name': 'Last name is required',
            'required.attendee_details.email_address': 'Email address is required'
        });

        setErrors(validation.errors?.errors);

        if (validation.passes()) {
            onAttendeeAdd({
                ...params,
                personSelected,
            });

            closePopup();
        }
    }

    const removeAttendee = (index) => {
       onAttendeeDelete(index);
       closePopup();
    }

    const onDetailsChange = (e) => {
        const { name, value } = e.target;
        const details = params?.attendee_details === undefined ? {} : { ...params.attendee_details };

        details[name] = value;

        onChange({ target: { name: 'attendee_details', value: details } })
    }

    const onChange = (e, callback = () => {}) => {
        const { name, value } = e.target;
        const p = { ...params }

        p[name] = value;

        setParams(p);
        callback();
    }

    const onUserSelected = ({ value }) => {
        const member = members?.find(member => member.id === value) || null;

        setPersonSelected(member);
        setErrors({});

        let data = {
            attendee_type: 'App\\Models\\User',
            attendee_id: value,
            event_ticket_type_id: params?.event_ticket_type_id 
        }

        if (member === null) {
            data = {
                event_ticket_type_id: params?.event_ticket_type_id 
            }
        }
        
        setParams(data);
    }

    const clear = () => {
        setParams({});
        setPersonSelected(null);
        setErrors({});
    }

    const onAttendeeTicketUpdate = (index, attendee, ticket) => {
        onAttendeeUpdate(index, {
            ...attendee,
            event_ticket_type_id: ticket,
        })
        closePopup();
    }

    useEffect(() => {
        companiesApi.getCompanyMembers(window.user.company_id).then(({ data }) => {
            setMembers(data);
        })
    }, []);

    return (
        <SidePopup title='Add Guests' className="add-guest">
            <ErrorContainer errors={errors?.attendee_id} className="add-guest__errors">
                <List gap="40px">
                    <ContentDropdown title={`New Attendee`} isOpen={true} toggleable={false}>
                        <List gap="20px">
                            <InputsDropdown
                                label="Select from your team"
                                reset
                                resetText="Select Something"
                                items={
                                    members?.filter((member) => {
                                        return !attendees?.map(attendee => attendee?.attendee?.id).includes(member.id)
                                    }).map((member) => {
                                        return {
                                            label: member?.name,
                                            value: member?.id,
                                        }
                                    })
                                }
                                value={personSelected?.id}
                                onChange={onUserSelected}
                            />

                            <InputsDropdown
                                label="Select a ticket type"
                                items={
                                    howManyTicketsLeftMapped.filter(ticket => ticket?.left > 0).map((ticket) => {
                                        return {
                                            label: `${ticket?.name} - RMNG Qty: ${ticket?.left}`,
                                            value: ticket?.id
                                        }
                                    })
                                }
                                value={params?.event_ticket_type_id}
                                onChange={e => {
                                    onChange({
                                        target: {
                                            name: 'event_ticket_type_id',
                                            value: e.value,
                                        }
                                    })
                                }}
                                errors={errors?.['event_ticket_type_id']}
                            />
                            
                            <Divider top="10px" bottom="10px"/>

                            <Blurred toggled={personSelected !== null}>
                                <List gap="20px">
                                    <InputsText 
                                        label="First Name"
                                        name="first_name"
                                        onChange={onDetailsChange}
                                        value={params?.attendee_details?.first_name || ''}
                                        errors={errors?.['attendee_details.first_name']}
                                    />
                            
                                    <InputsText 
                                        label="Last Name"
                                        name="last_name"
                                        onChange={onDetailsChange}
                                        value={params?.attendee_details?.last_name || ''}
                                        errors={errors?.['attendee_details.last_name']}
                                    />
                            
                                    <InputsText 
                                        label="Business Name"
                                        name="business_name"
                                        onChange={onDetailsChange}
                                        value={params?.attendee_details?.business_name || ''}
                                        errors={errors?.['attendee_details.business_name']}
                                    />
                            
                                    <InputsText 
                                        label="Email Address"
                                        name={'email_address'}
                                        onChange={onDetailsChange}
                                        value={params?.attendee_details?.email_address || ''}
                                        errors={errors?.['attendee_details.email_address']}
                                    />
                        
                                    <InputsText 
                                        label="Telephone"
                                        name={'phone_number'}
                                        onChange={onDetailsChange}
                                        value={params?.attendee_details?.phone_number || ''}
                                        errors={errors?.phone_number}
                                    />
                                </List>
                            </Blurred>

                            <Row gap="20px" wrap>
                                <ButtonSave onClick={save}>Add Attendee</ButtonSave>
                                <ButtonReturn onClick={clear}>Clear</ButtonReturn>
                            </Row>
                        </List>
                    </ContentDropdown>

                    <List gap="20px">
                        { attendees?.map((att, index) => {
                            const attendee = att.hasOwnProperty('attendee') ? att?.attendee : att?.attendee_details;

                            const selectedTicket = {
                                label: att?.event_ticket_type?.name,
                                value: att?.event_ticket_type?.id
                            }

                            const renderUser = () => {
                                return (
                                    <List gap="20px">
                                        <LabelContainer label={<Container.Text color="#1976F8">Name</Container.Text>}>
                                            { attendee?.name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Ticket Type</Container.Text>}>
                                            <InputsDropdown
                                                items={
                                                    howManyTicketsLeftMapped.filter(ticket => ticket?.left > 0).map((ticket) => {
                                                        return {
                                                            label: `${ticket?.name} - RMNG Qty: ${ticket?.left}`,
                                                            value: ticket?.id
                                                        }
                                                    })
                                                }
                                                value={selectedTicket}
                                                onChange={e => {
                                                    onAttendeeTicketUpdate(index, att, e.value);
                                                }}
                                            />
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Email Address</Container.Text>}>
                                            { attendee?.email }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Telephone</Container.Text>}>
                                            { attendee?.user_profile?.telephone }
                                        </LabelContainer>
                                    </List>
                                )
                            }

                            const renderContact = () => {
                                return (
                                    <List gap="20px">
                                        <LabelContainer label={<Container.Text color="#1976F8">First Name</Container.Text>}>
                                            { attendee?.first_name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Last Name</Container.Text>}>
                                            { attendee?.last_name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Ticket Type</Container.Text>}>
                                            <InputsDropdown
                                                items={
                                                    howManyTicketsLeftMapped.filter(ticket => ticket?.left > 0).map((ticket) => {
                                                        return {
                                                            label: `${ticket?.name} - RMNG Qty: ${ticket?.left}`,
                                                            value: ticket?.id
                                                        }
                                                    })
                                                }
                                                value={selectedTicket}
                                                onChange={e => {
                                                    onAttendeeTicketUpdate(index, att, e.value);
                                                }}
                                            />
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Email Address</Container.Text>}>
                                            { attendee?.email || attendee?.email_address }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Phone Number</Container.Text>}>
                                            { attendee?.phone_number }
                                        </LabelContainer>
                                    </List>
                                )
                            }
                            
                            return <ContentDropdown title={`Attendee ${index + 1}`} key={index} right={
                                <ButtonRemove mobile onClick={() => removeAttendee(index)}/>
                            }>
                                { attendee?.hasOwnProperty('name') ? renderUser() : renderContact() }
                            </ContentDropdown>
                        })}
                    </List>
                </List>
            </ErrorContainer>
        </SidePopup>
    )
}